import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { Metamodel } from '../base/model';
import { format } from 'app/shared/utils/string.util';

import { LinkedService } from './linkedservice';
import { IModel } from '../base/annotation';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { AzureKeyVault } from './key-vault';
import { getSqlPEResourceIDAndName, IPrivateEndpointCompatible } from 'shell-models-lib';

@Metamodel.model({
    name: adfModelTypeMap.azureMariaDB.linkedServiceType,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.AzureMariaDB_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.AzureMariaDB_DisplayText)
    ]
})
export class AzureMariaDBLinkedService extends LinkedService implements IPrivateEndpointCompatible {

    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServerName
    })
    public server?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Port
    })
    public port?: number;

    @Metamodel.attribute({
        display: stringResources.ModelName_DatabaseName
    })
    public databaseName?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_UserName
    })
    public userName?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Password,
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public password?: string | AzureKeyVault;

    public enableAKV?: boolean = false;
    @Metamodel.attribute({
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public referedAKV?: AzureKeyVault;

    public isLegacyConnector: boolean = true;

    private _serverResourceID: string;

    constructor(name?: string, description?: string) {
        super(name, description);
    }

    public getPEResourceIDAndName(): { id: string, name: string } {
        return getSqlPEResourceIDAndName(this.server, this._serverResourceID);
    }

    public setPEResourceID(id: string): void {
        this._serverResourceID = id;
    }
}
